import Const from '../util/Constants';
import config from '../config/config';

class CompanyAPI {

  static headers = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'client': 'WebClient'
  }
  
  static list = (body, success, failure, logout) => {
    fetch(`${config.url}/QvmorXOVuoI3Ee9q`, { method: 'POST', headers: CompanyAPI.headers, body: JSON.stringify(body) })
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static update = (body, success, failure, logout) => {
    fetch(`${config.url}/QvmorXOVuoI3Ee9q/edit`, { method: 'POST', 
      headers: CompanyAPI.headers, body: JSON.stringify(body)})
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static userList = (body, success, failure, logout) => {
    fetch(`${config.url}/QvmorXOVuoI3Ee9q/user`, 
      { method: 'POST', headers: CompanyAPI.headers, body: JSON.stringify(body)})
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static userUpdate = (body, success, failure, logout) => {
    fetch(`${config.url}/QvmorXOVuoI3Ee9q/user/edit`, 
      { method: 'POST', headers: CompanyAPI.headers, body: JSON.stringify(body)})
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }
}
export default CompanyAPI;